<template>
  <div class="container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell
            v-if="!config.disableCampus"
            title="校区"
            is-link
            :value-class="['van-ellipsis', campusText ? 'selected' : '']"
            :value="campusText || '请选择'"
            @click="chooseCampus"
          />
          <van-cell
            v-if="!config.disableCourse"
            title="课程"
            is-link
            :value-class="['van-ellipsis', params.curriculumName ? 'selected' : '']"
            :value="params.curriculumName || '请选择'"
            @click="choosePriceItem"
          />
          <van-cell
            title="班级"
            is-link
            :value-class="['van-ellipsis', params.className ? 'selected' : '']"
            :value="params.className || '请选择'"
            @click="chooseClass"
          />
          <div class="three-a-row" v-if="config.enableTagFilter">
            <div class="nav-title">学员状态</div>
            
            <div class="nav-div">            
              <div class="nav-box" v-for="item of stuStaList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.status && params.status.includes(item.val),
                    all: ((!params.status || !params.status.length) && item.val === ''),
                  }"
                  @click="triggerStuSta(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="!config.disableStatus">
            <div class="nav-title">补课状态</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of typesList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.remedyStatusList.includes(item.value),
                  }"
                  @click="typesItmeClick(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="!config.disableCourseStatus">
            <div class="nav-title">学员课程状态</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of courseTypesList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.courseRelations.includes(item.value),
                  }"
                  @click="typesItmeClick(item, 'courseRelations')"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="!config.hideDate">
            <div class="nav-title">时间区间</div>
            <div class="date-box">
              <input-date-range
                :start="params.startTime"
                :end="params.endTime"
                @change="chooseCalendar"
              ></input-date-range>
            </div>
          </div>
        </div>
        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm"> 确定 </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
import InputDateRange from '@x3/vue/comp/input-date-range.vue';

function getInitParams() {
  let startD = app.tool.date.getBasedOnToDayDate(-7);
  return {
    campusIds: [app.teacher.campusId],
    campusList: [app.teacher.campus],
    curriculumId: '',
    curriculumName: '',
    startTime: app.tool.date.formatDatetime(startD, 'yyyy-MM-dd'),
    endTime: app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd'),
    classId: '',
    className: '',
    remedyStatusList: [0],
    courseRelations: [],
    // 学员状态ids
    status: [1],
  };
}

export default {
  name: 'makeUpListFiltrate',
  components: { InputDateRange },
  inject: ['studentsStatusDict'],
  data() {
    return {
      visible: false,
      // 状态列表
      typesList: [
        { id: 1, name: '待安排补课', value: 0 },
        { id: 2, name: '已安排补课', value: 1 },
        { id: 3, name: '已完成补课', value: 2 },
        { id: 5, name: '不需要补课', value: 4 },
        { id: 4, name: '无需处理', value: 3 },
      ],
      // 状态列表
      courseTypesList: [
        { id: 1, name: '正常', value: 1 },
        { id: 0, name: '不再上课', value: 0 },
      ],
      params: getInitParams(),
      config: {
        hideDate: false,
        disableCampus: false,
        disableStatus: false,
        disableCourse: false,
        disableCourseStatus: false,
        // 是否开启学员状态筛选
        enableTagFilter: false,
        enableStudentStatusIds: [1, 6, 7],
      },
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    stuStaList() {
      let arr = [];
      for (let prop in this.studentsStatusDict) {
        this.config.enableStudentStatusIds.includes(Number(prop)) && arr.push({ id: prop, val: Number(prop), name: this.studentsStatusDict[prop] });
      }
      return arr;
    },
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }
        if (opts.config) {
          let config = JSON.parse(JSON.stringify(opts.config));
          this.config = Object.assign(this.config, config);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });

      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      console.log(oIdsStr, nOdsStr);
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;
        this.params.classId = '';
        this.params.className = '';
      }
    },
    async choosePriceItem() {
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumId,
        params: {
          campusIds: [...this.params.campusIds],
          chargeType: 1,
        }, 
        filter: {
          enableCampusFilter: false,
        },
        config: {
          radio: true,
        },
      });
      if (res && res.curriculumId && res.curriculumId !== this.params.curriculumId) {
        this.params.classId = '';
        this.params.className = '';
      }
      this.params.curriculumId = res ? res.curriculumId : '';
      this.params.curriculumName = res ? res.curriculumName : '';
    },
    // 选择班级
    async chooseClass() {
      let res = await app.x3.side.xsClass({
        id: this.params.classId,
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
          curriculumIds: this.params.curriculumId ? [this.params.curriculumId] : [],
          classStatus: '',
        },
        config: {
          radio: true,
          enableFilter: false,
        },
        filter: {
          enableCampusFilter: false,
        }
      });
      this.params.classId = res ? res.id : '';
      this.params.className = res ? res.className : '';
    },
    // 显示日期选择框
    chooseCalendar(ret) {
      this.params.startTime = ret.startDate;
      this.params.endTime = ret.endDate;
    },
    typesItmeClick(item, prop = 'remedyStatusList') {
      let param = this.params[prop];
      if (param.includes(item.value)) {
        let idx = param.indexOf(item.value);
        idx >= 0 && param.splice(idx, 1);
      } else {
        param.push(item.value);
      }
    },
    // 学员状态处理
    triggerStuSta(item) {
      let i = this.params.status.indexOf(item.val);
      if (i === -1) {
        this.params.status.push(item.val);
      } else {
        this.params.status.splice(i, 1);
      }
    },
    // 重置
    reset() {
      this.params = getInitParams();
    },
    doneAnima() {
      this.$router.back();
      return new Promise(rsv => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: {
              ...this.params,
              startTime: app.tool.date.formatDatetime(this.params.startTime, 'yyyy-MM-dd'),
              endTime: app.tool.date.formatDatetime(this.params.endTime, 'yyyy-MM-dd'),
            },
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
  },
  beforeDestroy() {},
  watch: {
    '$vxRoute.vx_action': function (nv, ov) {
      // console.log(nv);
      if (nv == 'vx-out') {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
    }
  }
}
</style>